import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<div class="${ctx.step === 0 ? 'd-none' : 'd-flex'} justify-content-center">
  <div class="steps ${ctx.step === 0? 'active': ''}">
    <div class="wizard-icon-group">
      <span class="step-icon ai ai-apply-licenses"></span>
      <span class="ai ai-chevron-right"></span>
    </div>
    <span>${until(ctx.__('<tt-g1oilekA>', '1) Upload Roster'))}</span>
  </div>
  <div class="steps ${ctx.step === 1? 'active': ''}">
    <div class="wizard-icon-group">
      <span class="step-icon ai ai-apply-licenses"></span>
      <span class="ai ai-chevron-right"></span>
    </div>
    <span>${until(ctx.__('<tt-mPBTBljV>', '2) Validate Roster'))}</span>
  </div>
  <div class="steps ${ctx.step === 2? 'active': ''}">
    <div class="wizard-icon-group">
      <span class="step-icon ai ai-apply-licenses"></span>
      <span class="ai ai-chevron-right"></span>
    </div>
    <span>${until(ctx.__('<tt-7ZJQgOV+>', '3) Apply Licenses'))}</span>
  </div>
</div>
`;
